"use strict"// Import loglevel
window.log = require('loglevel');
// log.warn("unreasonably simple");

import JustValidate from 'just-validate';
import Swal from 'sweetalert2';

// Process SCSS
import '../scss/rosinagroup.scss';

// Form Validation
const contactForm = document.querySelector('.contact-form');
if (contactForm) {
    const validator = new JustValidate(contactForm, {
        validateBeforeSubmitting: true,
    });

    validator
        .addField('#name', [
            {
                rule: 'required',
                errorMessage: 'Per favore inserisci il tuo nome.',
            },
            {
                rule: 'minLength',
                value: 3,
                errorMessage: 'Il nome deve essere di almeno 3 caratteri.',
            },
        ])
        .addField('#email', [
            {
                rule: 'required',
                errorMessage: 'Per favora inserisci un\'email.',
            },
            {
                rule: 'email',
                errorMessage: 'Per favore inserisci un\'email valida.',
            },
        ])
        .addField('#phone', [
            {
                rule: 'required',
                errorMessage: 'Per favore inserisci un numero di telefono.',
            },
        ])
        .addField('#subject', [
            {
                rule: 'required',
                errorMessage: 'Per favore scrivi l\'oggetto del messaggio.',
            },
        ])
        .addField('#message', [
            {
                rule: 'required',
                errorMessage: 'Per favore scrivi il tuo messaggio.',
            },
        ])
        .addField('#privacy', [
            {
                rule: 'required',
                errorMessage: 'Per favore accetta la Privacy Policy.',
            },
        ])
        .onSuccess((event) => {
            const form = event.target;
            const formData = new FormData(form);
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn.innerText;

            submitBtn.disabled = true;
            submitBtn.innerText = submitBtn.getAttribute('data-loading-text') || 'Invio in corso...';

            // Add the 'submit' parameter manually anyway since we are not clicking a button in a traditional form post
            // But for FormData, we can just append it if the PHP checks for it.
            // The existing PHP checked `isset($_GET['submit'])`, we will change PHP to rely on POST method or checking fields.
            // Let's assume we clean up PHP side.

            fetch(form.action + '.json', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Messaggio inviato!',
                        text: 'Grazie per averci contattato. Ti risponderemo al più presto.',
                        confirmButtonColor: '#0088cc' 
                    });
                    form.reset();
                    // Reset validation state if needed (JustValidate doesn't effectively clear errors on reset automatically in all versions, but reset() clears inputs which is main thing)
                } else {
                    let errorMessage = 'Si è verificato un errore.';
                    if (data.alert && data.alert.error) {
                        errorMessage = data.alert.error;
                    }
                     Swal.fire({
                        icon: 'error',
                        title: 'Errore',
                        html: errorMessage, // Allow HTML for bold text etc
                        confirmButtonColor: '#0088cc'
                    });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: 'Si è verificato un errore di rete. Riprova più tardi.',
                    confirmButtonColor: '#0088cc'
                });
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.innerText = originalBtnText;
            });
        });
}